import antdEn from 'antd/lib/locale-provider/es_ES';
import appLocaleData from 'react-intl/locale-data/es';
import enMessages from './es.json';

const esES = {
    messages: {
        ...enMessages,
    },
    antd: antdEn,
    locale: 'es-ES',
    data: appLocaleData,
};

export default esES;



// WEBPACK FOOTER //
// ./src/locales/es-ES.js